import * as React from 'react';
// @ts-expect-error
import type {LocationShape} from 'react-router-dom';

import classnames from 'classnames';

import {Link} from '../link/link';

import styles from './link-card.module.css';

type Props = {
    children: React.ReactNode;
    as?: string | React.ComponentType<any>;
    href?: string;
    to?: string | LocationShape;
    newTab?: boolean;
    /** If true, the card will size vertically according to the content, not the parent's height */
    fitHeight?: boolean;
    isFullWidth?: boolean;
    isFlex?: boolean;
    preventUnderline?: boolean;
    hasBorder?: boolean;
    hasShadow?: boolean;
    backgroundColor?: string;
    getCardRef?: any;
    onClick?: () => void;
};

export function LinkCard(props: Props) {
    const {
        children,
        as,
        fitHeight,
        isFullWidth,
        isFlex,
        backgroundColor,
        getCardRef,
        hasBorder = true,
        hasShadow = true,
        onClick,
        ...restProps
    } = props;

    const styleNames = classnames({
        [styles['link-card']]: true,
        [styles['link-card--bordered']]: hasBorder,
        [styles['link-card--shadowed']]: hasShadow,
        [styles['link-card--fitHeight']]: fitHeight,
        [styles['link-card--fullWidth']]: isFullWidth,
        [styles['link-card--flex']]: isFlex,
    });

    return (
        <div style={{backgroundColor}} ref={getCardRef} onClick={onClick} className={styleNames}>
            <Link as={as} {...restProps}>
                {children}
            </Link>
        </div>
    );
}
